// project import
import dashboard from './dashboard';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, support]
};

export default menuItems;
